import React from "react";

import Link from "next/link";

import {
  AppBar,
  Box,
  Divider,
  Hidden,
  IconButton,
  Link as MuiLink,
  Toolbar,
} from "@mui/material";

import PropTypes from "prop-types";

import MenuIcon from "../../icons/Menu";
import Logo from "../Logo";

const MainNavbar = ({ onOpenSidebar }) => (
  <AppBar
    elevation={0}
    sx={{
      backgroundColor: "background.paper",
      color: "text.secondary",
    }}
  >
    <Toolbar sx={{ minHeight: 64 }}>
      <Logo
        sx={{
          display: "inline",
        }}
      />
      <Box sx={{ flexGrow: 1 }} />
      <Hidden mdDown>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
          }}
        >
          <Box mx={1} />
          <Link href="/business" passHref>
            <MuiLink color="textSecondary" underline="hover">
              商業委託
            </MuiLink>
          </Link>
          <Box mx={1} />
          <Link href="/creator" passHref>
            <MuiLink color="textSecondary" underline="hover">
              成為創作者
            </MuiLink>
          </Link>
          <Box mx={1} />
          <Link
            href={
              process.env.NODE_ENV === "production"
                ? "https://www.flyingmilktea.com"
                : "."
            }
            passHref
          >
            <MuiLink color="textSecondary" underline="hover">
              飛天奶茶主頁
            </MuiLink>
          </Link>
          <Box mx={1} />
          <Link
            href={
              process.env.NODE_ENV === "production"
                ? "https://market.flyingmilktea.com"
                : "."
            }
            passHref
          >
            <MuiLink color="textSecondary" underline="hover">
              未來墟
            </MuiLink>
          </Link>
          <Box mx={1} />
          <Link href="/contact" passHref>
            <MuiLink color="textSecondary" underline="hover">
              聯絡我們
            </MuiLink>
          </Link>
        </Box>
      </Hidden>
      <Hidden mdUp>
        <IconButton color="inherit" onClick={onOpenSidebar}>
          <MenuIcon fontSize="small" />
        </IconButton>
      </Hidden>
    </Toolbar>
    <Divider />
  </AppBar>
);

MainNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default MainNavbar;
